'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.preload = exports.rendererFactory = undefined;

var _appnexus = require('./appnexus');

var _renderer = require('./renderer');

var _placement = require('./placement');

var _observer = require('./observer');

var observer = _interopRequireWildcard(_observer);

var _marginsConfig = require('./config/margins-config');

var _marginsConfig2 = _interopRequireDefault(_marginsConfig);

var _preloader = require('./preloader');

var _preloader2 = _interopRequireDefault(_preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var emptyFn = function emptyFn() {};

var rendererFactory = exports.rendererFactory = function rendererFactory(appnexusOptions) {
    var nativeRenderer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : emptyFn;

    var appnexus = (0, _appnexus.createAppnexusHandler)(appnexusOptions);
    var placementFactory = (0, _placement.createFactory)({
        appnexus: appnexus,
        observer: observer,
        marginsConfig: _marginsConfig2.default,
        nativeRenderer: nativeRenderer
    });
    var rendererOptions = { appnexus: appnexus, placementFactory: placementFactory };

    return (0, _renderer.createRenderer)(rendererOptions);
};

exports.preload = _preloader2.default;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-renderer/lib/index.js
 ** module id = 465
 ** module chunks = 1
 **/